import React, { useEffect, useRef, useState } from 'react';
import { Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap';
import classes from './Groups.module.scss';
import { boxiPrimary } from '../../../../assets/style/colors';
import axios from 'axios';
import { Button, Checkbox, Chip, Dialog, Divider, List, ListItemButton, ListItemIcon, ListItemText, Popover, TextField, Tooltip, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { LoadingButton } from '@mui/lab';
import InfiniteScroll from 'react-infinite-scroll-component';
import _ from 'lodash';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PersonIcon from '@mui/icons-material/Person';
import VendorSearch from '../VendorSearch/VendorSearch';
import InfoIcon from '@mui/icons-material/Info';
import moment from 'moment-timezone';
import { useToastContext } from '../../../../wrappers/ToastContext';

const Groups = ({ isModalOpen, openModal, setIsComposePopupOpen, setSelectedGroup, isSelection, setIsSelection, handleGroupToggle, checked }) => {
  const { toast } = useToastContext();
  
  const allowedCharacters = /^[0-9+\-()\s;]*$/;

  const [activeTab, setActiveTab] = useState(-1);

  const [isCampaignGroupsLoading, setIsCampaignGroupsLoading] = useState(true);
  const [campaignGroups, setCampaignGroups] = useState([]);
  const [totalCampaignGroups, setTotalCampaignGroups] = useState(0);
  const [campaignGroupsCurrentPage, setCampaignGroupsCurrentPage] = useState(0);
  const [hasMoreCampaignGroups, setHasMoreCampaignGroups] = useState(true);
  const [selectedCampaignGroup, setSelectedCampaignGroup] = useState(null);
  const [campaignPagesFetched, setCampaignPagesFetched] = useState([]);
  const [campaignSearchValue, setCampaignSearchValue] = useState(null);
  const [isCampaignSearchOn, setIsCampaignSearchOn] = useState(false);

  const [isCityGroupsLoading, setIsCityGroupsLoading] = useState(true);
  const [cityGroups, setCityGroups] = useState([]);
  const [totalCityGroups, setTotalCityGroups] = useState(0);
  const [cityGroupsCurrentPage, setCityGroupsCurrentPage] = useState(0);
  const [hasMoreCityGroups, setHasMoreCityGroups] = useState(true);
  const [selectedCityGroup, setSelectedCityGroup] = useState(null);
  const [cityPagesFetched, setCityPagesFetched] = useState([]);
  const [citySearchValue, setCitySearchValue] = useState(null);
  const [isCitySearchOn, setIsCitySearchOn] = useState(false);


  const [isCustomGroupsLoading, setIsCustomGroupsLoading] = useState(true);
  const [customGroups, setCustomGroups] = useState([]);
  const [totalCustomGroups, setTotalCustomGroups] = useState(0);
  const [customGroupsCurrentPage, setCustomGroupsCurrentPage] = useState(0);
  const [hasMoreCustomGroups, setHasMoreCustomGroups] = useState(true);
  const [selectedCustomGroup, setSelectedCustomGroup] = useState(null);
  const [customPagesFetched, setCustomPagesFetched] = useState([]);
  const [customSearchValue, setCustomSearchValue] = useState(null);
  const [isCustomSearchOn, setIsCustomSearchOn] = useState(false);

  const [isVendorsOnCampaignGroupsLoading, setIsVendorsOnCampaignGroupsLoading] = useState(true);
  const [vendorsOnCampaignGroups, setVendorsOnCampaignGroups] = useState([]);

  const [isAddModalOpen, closeAddNewModal] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [inputValue, setInputValue] = useState(null);
  const [isVendorSearchLoading, setIsVendorSearchLoading] = useState(false);
  const [isCustomGroupSaving, setIsCustomGroupSaving] = useState(false);
  const [groupInputValue, setGroupInputValue] = useState('');

  const [isGroupDuplicating, setIsGroupDuplicating] = useState(false);
  const [isGroupUpdating, setIsGroupUpdating] = useState(false);
  const [isEditModeOn, setEditModeOn] = useState(false);
  const [groupToEdit, setGroupToEdit] = useState(null);
  const [groupToEditName, setGroupToEditName] = useState('');
  const [groupVendorsToEdit, setGroupVendorsToEdit] = useState([]);

  const [vendorsToRemoveFromGroup, setVendorsToRemoveFromGroup] = useState([]);

  const [groupToDelete, setGroupToDelete] = useState(null);
  const [isDeleteAlertOn, setIsDeleteAlertOn] = useState(false);
  const [isGroupDeleting, setIsGroupDeleting] = useState(false);

  const [isSearchPopupOpen, setIsSearchPopupOpen] = useState(false);
  const [manualNumberValue, setManualNumberValue] = useState(null);
  const [manualAddedNumbers, setManualAddedNumbers] = useState([]);

  // const [numbersToAddInGroup, setNumbersToAddInGroup] = useState([]);

  useEffect(() => {
    if (!isEditModeOn) setManualAddedNumbers([])
  }, [isEditModeOn])

  useEffect(() => {
    const debouncedHandler = _.debounce(value => {
      if (value || value === '') {
        setIsCampaignSearchOn(true);
      }
    }, 1500);

    debouncedHandler(campaignSearchValue);

    return () => {
      debouncedHandler.cancel();
    };
  }, [campaignSearchValue]);

  useEffect(() => {
    const debouncedHandler = _.debounce(value => {
      if (value || value === '') {
        setIsCitySearchOn(true);
      }
    }, 1500);

    debouncedHandler(citySearchValue);

    return () => {
      debouncedHandler.cancel();
    };
  }, [citySearchValue]);

  useEffect(() => {
    const debouncedHandler = _.debounce(value => {
      if (value || value === '') {
        setIsCustomSearchOn(true);
      }
    }, 1500);

    debouncedHandler(customSearchValue);

    return () => {
      debouncedHandler.cancel();
    };
  }, [customSearchValue]);

  useEffect(() => {
    if (isModalOpen) setActiveTab(0);

    return () => {
      setCampaignGroups([]);
      setTotalCampaignGroups(0);
      setCampaignGroupsCurrentPage(0);
      setHasMoreCampaignGroups(true);
      setSelectedCampaignGroup(null);

      setCityGroups([]);
      setTotalCityGroups(0);
      setCityGroupsCurrentPage(0);
      setHasMoreCityGroups(true);
      setSelectedCityGroup(null);
    }
  }, [isModalOpen])

  useEffect(() => {
    if (activeTab === 0 && !campaignPagesFetched.includes(campaignGroupsCurrentPage)) {
      setCityPagesFetched([]);
      setCustomPagesFetched([]);
      setCityGroups([]);
      setCustomGroups([]);
      setCityGroupsCurrentPage(0);
      setCustomGroupsCurrentPage(0);
      fetchCampaignGroups(campaignGroupsCurrentPage);
    }
    else if (activeTab === 1 && !cityPagesFetched.includes(cityGroupsCurrentPage)) {
      setCampaignPagesFetched([]);
      setCustomPagesFetched([]);
      setCampaignGroups([]);
      setCustomGroups([]);
      setCampaignGroupsCurrentPage(0);
      setCustomGroupsCurrentPage(0);
      fetchCityGroups(cityGroupsCurrentPage);
    }
    else if (activeTab === 2 && !customPagesFetched.includes(customGroupsCurrentPage)) {
      setCampaignPagesFetched([]);
      setCityPagesFetched([]);
      setCampaignGroups([]);
      setCityGroups([]);
      setCampaignGroupsCurrentPage(0);
      setCityGroupsCurrentPage(0);
      fetchCustomGroups(customGroupsCurrentPage);
    }
    else if (activeTab === 3) {
      fetchVendorsOnCampaignGroups();
    }
  }, [activeTab])

  useEffect(() => {
    if (customGroups.length === 0 && customPagesFetched.length > 0) {
      setCustomPagesFetched([])
      fetchCustomGroups(0);
      setCustomGroupsCurrentPage(0);
    }
  }, [customGroups])

  const fetchCampaignGroups = async (page) => {
    try {
      const params = { page: page }
      if (campaignSearchValue !== '') params['keyword'] = campaignSearchValue
      const res = await axios.get(`${process.env.REACT_APP_API_HOST}/communication/group/campaigns`, { params });
      let tempCampaignGroups = _.cloneDeep(campaignGroups)
      if (isCampaignSearchOn) tempCampaignGroups = []
      tempCampaignGroups = [...tempCampaignGroups, ...res.data.campaigns]
      setCampaignGroups(tempCampaignGroups);
      setTotalCampaignGroups(+res.data.totalCampaigns)
      setHasMoreCampaignGroups(!(tempCampaignGroups.length === +res.data.totalCampaigns))
      setIsCampaignGroupsLoading(false);
      const temp = campaignPagesFetched
      temp.push(page)
      setCampaignPagesFetched(temp)
      setIsCampaignSearchOn(false)
    } catch (error) {
      setIsCampaignGroupsLoading(false);
    }
  }

  useEffect(() => {
    if (isCampaignSearchOn) fetchCampaignGroups(0);
  }, [isCampaignSearchOn])

  const fetchNextCampaignGroups = () => {
    setCampaignGroupsCurrentPage(prevPage => prevPage + 1);
    fetchCampaignGroups(campaignGroupsCurrentPage + 1);
  }

  const fetchCityGroups = async (page) => {
    try {
      const params = { page }
      if (citySearchValue !== '') params['keyword'] = citySearchValue
      const res = await axios.get(`${process.env.REACT_APP_API_HOST}/communication/group/cities`, { params });
      let tempCityGroups = _.cloneDeep(cityGroups)
      if (isCitySearchOn) tempCityGroups = []
      tempCityGroups = [...tempCityGroups, ...res.data.cities]
      setCityGroups(tempCityGroups);
      setTotalCityGroups(+res.data.totalCities)
      setHasMoreCityGroups(!(tempCityGroups.length === +res.data.totalCities))
      setIsCityGroupsLoading(false);
      const temp = cityPagesFetched
      temp.push(page)
      setCityPagesFetched(temp)
      setIsCitySearchOn(false)
    } catch (error) {
      setIsCityGroupsLoading(false);
    }
  }

  useEffect(() => {
    if (isCitySearchOn) fetchCityGroups(0);
  }, [isCitySearchOn])

  const fetchNextCityGroups = () => {
    setCityGroupsCurrentPage(prevPage => prevPage + 1);
    fetchCityGroups(cityGroupsCurrentPage + 1);
  }

  const fetchCustomGroups = async (page) => {
    try {
      const params = { page }
      if (customSearchValue !== '') params['keyword'] = customSearchValue
      const res = await axios.get(`${process.env.REACT_APP_API_HOST}/communication/group/custom`, { params });
      let tempCustomGroups = _.cloneDeep(customGroups)
      if (isCustomSearchOn) tempCustomGroups = []
      tempCustomGroups = [...tempCustomGroups, ...res.data.groups]
      setCustomGroups(tempCustomGroups);
      setTotalCustomGroups(+res.data.totalGroups)
      setHasMoreCustomGroups(!(tempCustomGroups.length === +res.data.totalGroups))
      setIsCustomGroupsLoading(false);
      const temp = customPagesFetched
      temp.push(page)
      setCustomPagesFetched(temp)
      setIsCustomSearchOn(false)
    } catch (error) {
      setIsCustomGroupsLoading(false);
    }
  }

  useEffect(() => {
    if (isCustomSearchOn) fetchCustomGroups(0);
  }, [isCustomSearchOn])

  const fetchNextCustomGroups = () => {
    setCustomGroupsCurrentPage(prevPage => prevPage + 1);
    fetchCustomGroups(customGroupsCurrentPage + 1);
  }

  const fetchVendorsOnCampaignGroups = async () => {
    try {
      setIsVendorsOnCampaignGroupsLoading(true);
      const res = await axios.get(`${process.env.REACT_APP_API_HOST}/communication/group/vendors_on_campaign`);
      setVendorsOnCampaignGroups(res.data.vendorsOnCampaignGroups);
      setIsVendorsOnCampaignGroupsLoading(false);
    } catch (error) {
      setIsVendorsOnCampaignGroupsLoading(false);
      console.log(error);
    }
  }

  const generateAvatarBackgroundColor = (name) => {
    let numericValue = 0;
    for (let i = 0; i < name.length; i++) {
      numericValue += name.charCodeAt(i);
    }
    const hue = numericValue % 360; // Use modulo to restrict the hue to a range of 0-359
    const saturation = 70; // Set a fixed saturation value
    const lightness = 50; // Set a fixed lightness value
    const color = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    return color;
  };

  const selectTab = (index) => {
    setActiveTab(index);
    setSelectedCampaignGroup(null);
    setSelectedCityGroup(null);
    setSelectedCustomGroup(null);
    setTimeout(() => {
      index === 1 && window.dispatchEvent(new Event('resize'));
    }, 1);
  }

  const checkIfVendorIsSelected = (vendor) => {
    return selectedVendors.map(v => v.vendor_id).indexOf(vendor.vendor_id) === -1 ? false : true;
  } 

  const addVendorToSelectedList = (vendor) => {
    if (!checkIfVendorIsSelected(vendor)) {
      const tempSelectedVendors = _.cloneDeep(selectedVendors)
      tempSelectedVendors.push(vendor);
      setSelectedVendors(tempSelectedVendors);
    }
  }

  useEffect(() => {
    const debouncedHandler = _.debounce(value => {
      if (value !== null) {
        searchVendors();
      } else setVendors([]);
    }, 1000);

    debouncedHandler(inputValue);

    return () => {
      debouncedHandler.cancel();
    };
  }, [inputValue]);

  const searchVendors = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_HOST}/communication/chat/search-vendor/${inputValue}`);
      setVendors(res.data.vendors)
    } catch (error) {
      console.error(error)
    }
  }

  const removeSelectedVendor = (index) => {
    const tempSelectedVendors = _.cloneDeep(selectedVendors);
    tempSelectedVendors.splice(index, 1);
    setSelectedVendors(tempSelectedVendors);
  }

  const createCustomGroup = async () => {
    try {
      const numbersToAddInGroup = []
      if (selectedVendors?.length > 0) numbersToAddInGroup.push(...selectedVendors.map((vendor => { return { vendor_id: vendor.vendor_id, phone_number: vendor.phone_num }} )))
      if (manualAddedNumbers?.length > 0) numbersToAddInGroup.push(...manualAddedNumbers.map(number => {return {vendor_id: null, phone_number: number}}));

      setIsCustomGroupSaving(true);
      const res = await axios.post(`${process.env.REACT_APP_API_HOST}/communication/group/custom`, { group_name: groupInputValue, group_numbers: JSON.stringify(numbersToAddInGroup), created_by: JSON.parse(localStorage.getItem("userId")) })
      setIsCustomGroupSaving(false);
      closeAddNewModal(false);
      setVendors([]);
      setSelectedVendors([]);
      setCustomGroups([]);
      setManualAddedNumbers([]);
      toast.success('Custom group created!')
    } catch (error) {
      setIsCustomGroupSaving(false);
      console.error(error)
    }
  }

  const duplicateGroup = async (group_name, group_vendors) => {
    try {
      setIsGroupDuplicating(true);
      const group_vendor_ids = JSON.stringify(group_vendors.map((vendor => { return { vendor_id: vendor.vendor_id ? vendor.vendor_id : null, phone_number: vendor.phone_number }} )));
      const res = await axios.post(`${process.env.REACT_APP_API_HOST}/communication/group/custom`, { group_name: group_name + ' - Copy', group_numbers: group_vendor_ids, created_by: JSON.parse(localStorage.getItem("userId")) })
      setCustomGroups([]);
      setIsGroupDuplicating(false);
      toast.success('Group duplicated successfully!')
    } catch (error) {
      setIsGroupDuplicating(false);
      console.error(error)
    }
  }

  const openEditMode = (group) => {
    setEditModeOn(true);
    setGroupToEdit(group);
    setGroupToEditName(group?.group_name)
    setGroupVendorsToEdit(group?.vendors.filter(v => v.vendor_id));
    setManualAddedNumbers(group?.vendors.filter(v => !v.vendor_id).map(v => v.phone_number));
  }

  const addVendorToGroupVendorsToEdit = (vendor) => {
    if (!checkIfVendorIsAddToEditGroup(vendor)) {
      const tempGroupVendorsToEdit = _.cloneDeep(groupVendorsToEdit);
      tempGroupVendorsToEdit.push({
        vendor_id: vendor.vendor_id,
        vendor_name: vendor.name,
        phone_number: vendor.phone_num
      })
      setGroupVendorsToEdit(tempGroupVendorsToEdit);

      const tempRemovedVendor = _.cloneDeep(vendorsToRemoveFromGroup);
      const removedIndex = tempRemovedVendor.indexOf(vendor.vendor_id)
      if (removedIndex > -1) {
        tempRemovedVendor.splice(removedIndex, 1);
      }
      setVendorsToRemoveFromGroup(tempRemovedVendor);
    }
  }

  const removeVendorFromGroupToEdit = (index) => {
    const tempSelectedVendors = _.cloneDeep(groupVendorsToEdit);
    const removedVendor = tempSelectedVendors.splice(index, 1);

    const tempRemovedVendor = _.cloneDeep(vendorsToRemoveFromGroup);
    const removedIndex = tempRemovedVendor.indexOf(removedVendor[0].phone_number)
    if (removedIndex > -1) {
      tempRemovedVendor.splice(removedIndex, 1);
    } else tempRemovedVendor.push(removedVendor[0].phone_number)

    setVendorsToRemoveFromGroup(tempRemovedVendor);
    setGroupVendorsToEdit(tempSelectedVendors);
  }

  const checkIfVendorIsAddToEditGroup = (vendor) => {
    return groupVendorsToEdit.map(v => v.phone_number).indexOf(vendor.phone_number) === -1 ? false : true;
  }

  const updateCustomGroup = async () => {
    try {
      setIsGroupUpdating(true);

      const numbersToAddInGroup = []
      if (groupVendorsToEdit?.length > 0) numbersToAddInGroup.push(...groupVendorsToEdit.map((vendor => { return { vendor_id: vendor.vendor_id, phone_number: vendor.phone_number ? vendor.phone_number : vendor.phone_num }} )))
      if (manualAddedNumbers?.length > 0) numbersToAddInGroup.push(...manualAddedNumbers.map(number => {return {vendor_id: null, phone_number: number}}));

      const res = await axios.patch(`${process.env.REACT_APP_API_HOST}/communication/group/custom/${groupToEdit.id}`, { 
        group_name: groupToEditName, 
        group_vendor_ids: JSON.stringify(numbersToAddInGroup), 
        vendors_to_remove: JSON.stringify(vendorsToRemoveFromGroup), 
        created_by: JSON.parse(localStorage.getItem("userId"))
      })
      setCustomGroups([]);
      setSelectedCustomGroup(null);
      setIsGroupUpdating(false);
      setEditModeOn(false);
      setGroupToEdit(null);
      setGroupToEditName('')
      setGroupVendorsToEdit([]);
      setVendorsToRemoveFromGroup([]);
      setManualAddedNumbers([]);
      toast.success('Custom group updated successfully!')
    } catch (error) {
      setIsGroupUpdating(false);
      console.error(error);
      console.log('error in updating >>>>>>');
    }
  }
  
  const deleteGroup = async () => {
    try {
      setIsGroupDeleting(true);
      const res = await axios.delete(`${process.env.REACT_APP_API_HOST}/communication/group/custom/${groupToDelete.id}`);
      setIsGroupDeleting(false);
      setIsDeleteAlertOn(false);
      setSelectedCustomGroup(null);
      setGroupToEdit(null);
      setEditModeOn(false);
      setCustomGroupsCurrentPage(0);
      setCustomGroups([]);
      toast.success('Custom group deleted successfully!')
    } catch (error) {
      setIsGroupDeleting(false);
      console.log(error);
    }
  }

  const handleDeleteChip = (vendor) => {
    const tempSelectedVendors = _.cloneDeep(selectedVendors);
    setSelectedVendors(tempSelectedVendors.filter(v => v.phone_num !== vendor.phone_num))
  }

  // useEffect(() => {
  //   if (manualNumberValue) {
  //     const splittedNumbers = manualNumberValue?.split(';');
  //     if (splittedNumbers.length > 1) {
  //       let tempManualAddedNumbers = _.cloneDeep(manualAddedNumbers);
  //       tempManualAddedNumbers = [...tempManualAddedNumbers, ...splittedNumbers.filter(number => number !== '')];
  //       setManualAddedNumbers(tempManualAddedNumbers);
  //       setManualNumberValue('');
  //     }
  //   }
  // }, [manualNumberValue])

  const handleManualNumberDeleteChip = (number) => {
    const tempManualAddedNumbers = _.cloneDeep(manualAddedNumbers);
    setManualAddedNumbers(tempManualAddedNumbers.filter(n => n !== number))
    const tempRemovedNumber = _.cloneDeep(vendorsToRemoveFromGroup);
    tempRemovedNumber.push(...tempManualAddedNumbers.filter(n => n == number))
    setVendorsToRemoveFromGroup(tempRemovedNumber);
  }

  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = handleFileRead;
      reader.readAsText(file);
    }
  };

  const formatPhoneNumberToE164 = (phoneNumber) => {
    const numericPhoneNumber = phoneNumber.replace(/\D/g, '');
    return numericPhoneNumber.length === 10 ? `+1${numericPhoneNumber}` : `+${numericPhoneNumber}`;
  }

  const removeCommas = (content) => {
    // Split the CSV content into an array of lines
    const lines = content.split('\n');

    // Process each line to remove commas
    const processedLines = lines.map((line) => line.replace(/,/g, ''));

    // Join the lines back into a single string without commas
    const result = processedLines.join('\n');
    return result;
  };
  
  const handleFileRead = (event) => {
    const fileContent = event.target.result;
    const phoneRegex = /(?:(?:\+?1[-.\s]?)?\(?(\d{3})\)?[-.\s]?)?(\d{3})[-.\s]?(\d{4})\b/g;

    const extractedPhoneNumbers = fileContent.match(phoneRegex);
    if (extractedPhoneNumbers) {
      const uniquePhoneNumbers = new Set();

      extractedPhoneNumbers.forEach((phoneNumber) => {
        const formattedPhoneNumber = formatPhoneNumberToE164(phoneNumber);
        if (formattedPhoneNumber.length >= 11) uniquePhoneNumbers.add(formattedPhoneNumber);
      });

      const uniquePhoneNumbersArray = Array.from(uniquePhoneNumbers);

      setPhoneNumbers(uniquePhoneNumbersArray);
      let tempManualAddedNumbers = _.cloneDeep(manualAddedNumbers);
      tempManualAddedNumbers = [...tempManualAddedNumbers, ...uniquePhoneNumbersArray]
      console.log(uniquePhoneNumbersArray.length);
      setManualAddedNumbers(tempManualAddedNumbers)
    } else {
      setPhoneNumbers([]);
    }
  };

  const toggleAddNewModal = () => {
    closeAddNewModal(false);
    setSelectedVendors([]);
    setManualAddedNumbers([]);
    setGroupInputValue('');
    setManualNumberValue('');
  }

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;


  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      const newInputValue = manualNumberValue + ';';
      setManualNumberValue(newInputValue);
  
      let inputParts = []
      if (newInputValue.includes(';')) inputParts = newInputValue.split(';');
  
      // Iterate through parts and validate them
      for (const part of inputParts) {
        const trimmedPart = part.trim(); // Remove extra spaces
        if (validatePhoneNumber(trimmedPart)) {
          let tempManualNumbers = _.cloneDeep(manualAddedNumbers)
          tempManualNumbers = tempManualNumbers.filter(number => number !== formatPhoneNumberToE164(trimmedPart))
          tempManualNumbers.push(formatPhoneNumberToE164(trimmedPart))
          console.log("🚀 ~ file: Communication.js:358 ~ handleInputChange ~ tempManualNumbers:", tempManualNumbers)
          setManualAddedNumbers(tempManualNumbers);
          setManualNumberValue('');
        }
      }
    }
  };

  const handleInputChange = (event) => {
    if (event.target.value.match(allowedCharacters)) {
      const newInputValue = event.target.value;
      setManualNumberValue(newInputValue);
  
      let inputParts = []
      if (newInputValue.includes(';')) inputParts = newInputValue.split(';');
  
      // Iterate through parts and validate them
      for (const part of inputParts) {
        const trimmedPart = part.trim(); // Remove extra spaces
        if (validatePhoneNumber(trimmedPart)) {
          let tempManualNumbers = _.cloneDeep(manualAddedNumbers)
          tempManualNumbers = tempManualNumbers.filter(number => number !== formatPhoneNumberToE164(trimmedPart))
          tempManualNumbers.push(formatPhoneNumberToE164(trimmedPart))
          console.log("🚀 ~ file: Communication.js:358 ~ handleInputChange ~ tempManualNumbers:", tempManualNumbers)
          setManualAddedNumbers(tempManualNumbers);
          setManualNumberValue('');
        }
      }
    }
  };

  const validatePhoneNumber = (value) => {
    // Validate the three formats
    const validFormats = [
      /^\d{10}$/, // 1112223333
      /^\+1\d{10}$/, // +12223334444
      /^\(\d{3}\)\s?\d{3}-\d{4}$/, // (222) 333-4444
      /^\+1\(\d{3}\)\s?\d{3}-\d{4}$/, // +1(222) 333-4444
      /^\+1\s\(\d{3}\)\s?\d{3}-\d{4}$/ // +1 (222) 333-4444

    ];
    // Check if the value matches any of the valid formats
    return validFormats.some((format) => format.test(value));
  };

  const handlePaste = (event) => {
    const clipboardData = event.clipboardData;
    const pastedData = clipboardData.getData('text/plain');
    const cleanedData = pastedData.replace(/;\s+/g, ';');
    event.preventDefault();
    setManualNumberValue(cleanedData);
  };

  const duplicateVendorOnCampaignGroup = async () => {
    try {
      setIsGroupDuplicating(true);
      const group_vendor_ids = JSON.stringify(vendorsOnCampaignGroups.map((vendor => { return { vendor_id: vendor.vendor_id ? vendor.vendor_id : null, phone_number: vendor.phone_number }} )));
      console.log({ group_name: `Vendors on Campaign - ${moment.tz('America/Los_Angeles').format('MMM')}`, group_numbers: JSON.parse(group_vendor_ids), created_by: JSON.parse(localStorage.getItem("userId")) });
      const res = await axios.post(`${process.env.REACT_APP_API_HOST}/communication/group/custom`, { group_name: `Vendors on Campaign - ${moment.tz('America/Los_Angeles').format('MMM')}`, group_numbers: group_vendor_ids, created_by: JSON.parse(localStorage.getItem("userId")) })
      setCustomGroups([]);
      setIsGroupDuplicating(false);
      toast.success('Group duplicated successfully!')
    } catch (error) {
      setIsGroupDuplicating(false);
      console.error(error)
    }
  }

  return (
    <>
      <Modal backdrop="static" className="composeModal" isOpen={isModalOpen} toggle={() => { setIsSelection(false); openModal(false); }}>
        <ModalHeader toggle={() => { setIsSelection(false); openModal(false); }}>Groups</ModalHeader>
        <ModalBody style={{ padding: 0, minHeight: 400, maxHeight: 400, position: 'relative' }}>
          {(isGroupDuplicating || isGroupUpdating) && <div className={classes.loaderOverlay}>
            <Spinner style={{ color: boxiPrimary }} />
          </div>}
          <div className={classes.tabs}>
            <div onClick={() => selectTab(0)} className={activeTab === 0 ? classes.activeTab : classes.tab}>
              Campaign
            </div>
            <div onClick={() => selectTab(1)} className={activeTab === 1 ? classes.activeTab : classes.tab}>
              City
            </div>
            <div onClick={() => selectTab(3)} className={activeTab === 3 ? classes.activeTab : classes.tab}>
              Vendors on Campaign
            </div>
            <div onClick={() => selectTab(2)} className={activeTab === 2 ? classes.activeTab : classes.tab}>
              Custom
            </div>
          </div>

          {/* Campaign Groups */}
          {activeTab === 0 && <div style={{ paddingLeft: '1rem', paddingRight: '1rem' }}>
            {isCampaignGroupsLoading ?
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 100 }}>
                <Spinner style={{ color: boxiPrimary }} />
              </div>
              :
              <Row style={{ maxHeight: 'inherit', minHeight: 'inherit', position: 'relative' }}>
                <Col sm="4" id="infinite-scroll-container" style={{ padding: 0, borderRight: '1px solid #ccc', maxHeight: 'inherit', minHeight: 'inherit', overflow: 'auto' }}>
                  <div style={{ position: 'relative' }}>
                    <TextField
                      id="thread-search"
                      type='search'
                      label="Search Campaign"
                      value={campaignSearchValue}
                      onChange={(e) => setCampaignSearchValue(e.target.value)}
                      variant="standard"
                      className="MuiTextField-standard-shrinked"
                    />
                    {isCampaignSearchOn && <div style={{ position: 'absolute', bottom: 4, right: 35 }}><Spinner size='sm' style={{ color: boxiPrimary }} /></div>}
                  </div>
                  <List sx={{ width: '100%', paddingTop: '4px', paddingBottom: '4px' }} component="nav" aria-label="vendor-options">
                    <InfiniteScroll
                      dataLength={campaignGroups.length}
                      hasMore={hasMoreCampaignGroups}
                      next={fetchNextCampaignGroups}
                      height={300}
                      loader={hasMoreCampaignGroups && <div style={{ margin: '10px auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Spinner size='sm' style={{ color: boxiPrimary }} /></div>}
                    >
                      {campaignGroups && campaignGroups.length > 0 && campaignGroups.map((campaignGroup, index) => (
                        <>
                          <ListItemButton selected={campaignGroup?.name == selectedCampaignGroup?.name} sx={{ columnGap: '10px', cursor: 'pointer', justifyContent: 'space-between' }}>
                            {isSelection && <ListItemIcon onClick={() => handleGroupToggle(campaignGroup)}>
                              <Checkbox
                                edge="start"
                                checked={checked.filter(val => val.campaign_id).map(val => val.campaign_id).indexOf(campaignGroup.campaign_id) !== -1}
                                tabIndex={-1}
                                disableRipple
                                inputProps={{ 'aria-labelledby': campaignGroup?.name }}
                              />
                            </ListItemIcon>}
                            <Tooltip placement="top" title={campaignGroup.name}>
                              <ListItemText id={campaignGroup?.name} onClick={() => { setSelectedCampaignGroup(campaignGroup); }} disableTypography={true} sx={{ fontFamily: 'Poppins', fontSize: 14, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '88%'}} primary={campaignGroup.name} />
                            </Tooltip>
                            <div className={classes.vendorCount}>{campaignGroup?.vendors?.length}</div>
                            <ContentCopyIcon onClick={() => duplicateGroup(campaignGroup?.name, campaignGroup?.vendors)} fontSize='16' color='secondary' />
                          </ListItemButton>
                          <Divider />
                        </>
                      ))}
                    </InfiniteScroll>
                  </List>
                </Col>
                <Col sm="8" style={{ maxHeight: 350, minHeight: 350, overflow: 'auto' }}>
                  <div style={{ paddingTop: 20, paddingBottom: 10, fontWeight: 500, position: 'sticky', top: 0, backgroundColor: 'white' }}>{selectedCampaignGroup?.name}</div>
                  <div className={classes.vendorCards}>
                    {selectedCampaignGroup && selectedCampaignGroup.vendors && selectedCampaignGroup.vendors.length > 0 && selectedCampaignGroup.vendors.map((vendor, index) => {
                      return (
                        <div className={`d-flex bg-white p-2 overflow-hidden text-truncate ${classes.vendorCard}`}>
                         {vendor?.vendor_name && <div className={classes.picture} style={{ backgroundColor: generateAvatarBackgroundColor(vendor?.vendor_name) }}>{vendor.vendor_name[0] === '+' ? <PersonIcon /> : vendor?.vendor_name.trim().split(' ').slice(0,2).reduce((acc, name) => acc+name[0],'')}</div>}
                          <div className={`overflow-hidden`}>
                            {vendor?.vendor_name && <div className="overflow-hidden text-truncate" style={{fontSize: '15px', fontWeight: '500'}}>{vendor?.vendor_name}</div>}
                            <div className="overflow-hidden text-truncate" style={{fontSize: '12px'}}>{vendor?.phone_number}</div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </Col>
              </Row>
            }
          </div>}

          {/* City Groups */}
          {activeTab === 1 && <div style={{ paddingLeft: '1rem', paddingRight: '1rem' }}>
            {isCityGroupsLoading ?
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 100 }}>
                <Spinner style={{ color: boxiPrimary }} />
              </div>
              :
              <Row style={{ maxHeight: 'inherit', minHeight: 'inherit' }}>
                <Col sm="4" id="infinite-scroll-container" style={{ padding: 0, borderRight: '1px solid #ccc', maxHeight: 'inherit', minHeight: 'inherit', overflow: 'auto' }}>
                  <div style={{ position: 'relative' }}>
                    <TextField
                      id="city-search"
                      type='search'
                      label="Search City"
                      value={citySearchValue}
                      onChange={(e) => setCitySearchValue(e.target.value)}
                      variant="standard"
                      className="MuiTextField-standard-shrinked"
                    />
                    {isCitySearchOn && <div style={{ position: 'absolute', bottom: 4, right: 35 }}><Spinner size='sm' style={{ color: boxiPrimary }} /></div>}
                  </div>
                  <List sx={{ width: '100%', paddingTop: '4px', paddingBottom: '4px' }} component="nav" aria-label="vendor-options">
                    <InfiniteScroll
                      dataLength={cityGroups.length}
                      hasMore={hasMoreCityGroups}
                      next={fetchNextCityGroups}
                      height={300}
                      loader={hasMoreCityGroups && <div style={{ margin: '10px auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Spinner size='sm' style={{ color: boxiPrimary }} /></div>}
                    >
                      {cityGroups && cityGroups.length > 0 && cityGroups.map((cityGroup, index) => (
                        <>
                          <ListItemButton selected={cityGroup?.city == selectedCityGroup?.city} sx={{ columnGap: '10px', cursor: 'pointer' }}>
                            {isSelection && <ListItemIcon onClick={() => handleGroupToggle(cityGroup)}>
                              <Checkbox
                                edge="start"
                                checked={checked.filter(val => val.city).map(val => val.city).indexOf(cityGroup.city) !== -1}
                                tabIndex={-1}
                                disableRipple
                                inputProps={{ 'aria-labelledby': cityGroup?.name }}
                              />
                            </ListItemIcon>}
                            <Tooltip placement="top" title={cityGroup.city}>
                              <ListItemText onClick={() => { setSelectedCityGroup(cityGroup); }} disableTypography={true} sx={{ fontFamily: 'Poppins', fontSize: 14, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}} primary={cityGroup.city} />
                            </Tooltip>
                            <div className={classes.vendorCount}>{cityGroup?.vendors?.length}</div>
                            <ContentCopyIcon onClick={() => duplicateGroup(cityGroup?.city, cityGroup?.vendors)} fontSize='16' color='secondary' />
                          </ListItemButton>
                          <Divider />
                        </>
                      ))}
                    </InfiniteScroll>
                  </List>
                </Col>
                <Col sm="8" style={{ maxHeight: 350, minHeight: 350, overflow: 'auto' }}>
                  <div style={{ paddingTop: 20, paddingBottom: 10, fontWeight: 500, position: 'sticky', top: 0, backgroundColor: 'white' }}>{selectedCityGroup?.city}</div>
                  <div className={classes.vendorCards}>
                    {selectedCityGroup && selectedCityGroup.vendors && selectedCityGroup.vendors.length > 0 && selectedCityGroup.vendors.map((vendor, index) => {
                      return (
                        <div className={`d-flex bg-white p-2 overflow-hidden text-truncate ${classes.vendorCard}`}>
                          {vendor?.vendor_name && <div className={classes.picture} style={{ backgroundColor: generateAvatarBackgroundColor(vendor?.vendor_name) }}>{vendor.vendor_name[0] === '+' ? <PersonIcon /> : vendor?.vendor_name.trim().split(' ').slice(0,2).reduce((acc, name) => acc+name[0],'')}</div>}
                          <div className={`overflow-hidden`}>
                            {vendor?.vendor_name && <div className="overflow-hidden text-truncate" style={{fontSize: '15px', fontWeight: '500'}}>{vendor?.vendor_name}</div>}
                            <div className="overflow-hidden text-truncate" style={{fontSize: '12px'}}>{vendor?.phone_number}</div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </Col>
              </Row>
            }
          </div>}

          {/* Custom Groups */}
          {activeTab === 2 && <div style={{ paddingLeft: '1rem', paddingRight: '1rem' }}>
            {isCustomGroupsLoading ?
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 100 }}>
                <Spinner style={{ color: boxiPrimary }} />
              </div>
              :
              <Row style={{ maxHeight: 'inherit', minHeight: 'inherit' }}>
                <Col sm="4" id="infinite-scroll-container" style={{ padding: 0, borderRight: '1px solid #ccc', maxHeight: 'inherit', minHeight: 'inherit', overflow: 'auto' }}>
                  <div style={{ position: 'relative' }}>
                    <TextField
                      id="custom-search"
                      type='search'
                      label="Search Group"
                      value={customSearchValue}
                      onChange={(e) => setCustomSearchValue(e.target.value)}
                      variant="standard"
                      className="MuiTextField-standard-shrinked"
                    />
                    {isCustomSearchOn && <div style={{ position: 'absolute', bottom: 4, right: 35 }}><Spinner size='sm' style={{ color: boxiPrimary }} /></div>}
                  </div>
                  <List sx={{ width: '100%', paddingTop: '4px', paddingBottom: '4px' }} component="nav" aria-label="vendor-options">
                    <InfiniteScroll
                      dataLength={customGroups.length}
                      hasMore={hasMoreCustomGroups}
                      next={fetchNextCustomGroups}
                      height={300}
                      loader={hasMoreCustomGroups && <div style={{ margin: '10px auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Spinner size='sm' style={{ color: boxiPrimary }} /></div>}
                    >
                      {customGroups && customGroups.length > 0 && customGroups.map((customGroup, index) => (
                        <>
                          <ListItemButton selected={customGroup?.id == selectedCustomGroup?.id} sx={{ columnGap: '10px', cursor: 'pointer' }}>
                            {isSelection && <ListItemIcon onClick={() => handleGroupToggle(customGroup)}>
                              <Checkbox
                                edge="start"
                                checked={checked.filter(val => val.id).map(val => val.id).indexOf(customGroup.id) !== -1}
                                tabIndex={-1}
                                disableRipple
                                inputProps={{ 'aria-labelledby': customGroup?.name }}
                              />
                            </ListItemIcon>}
                            <Tooltip placement="top" title={customGroup.group_name}>
                              <ListItemText onClick={() => { setSelectedCustomGroup(customGroup); setEditModeOn(false); }} disableTypography={true} sx={{ fontFamily: 'Poppins', fontSize: 14, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}} primary={customGroup.group_name} />
                            </Tooltip>
                            <div className={classes.vendorCount}>{customGroup?.vendors?.length}</div>
                            <div style={{ display: 'flex', flexWrap: 'nowrap', columnGap: 4 }}>
                              <EditIcon onClick={() => { openEditMode(customGroup); setSelectedCustomGroup(customGroup) }} fontSize='16' color='primary' />
                              <ContentCopyIcon onClick={() => duplicateGroup(customGroup?.group_name, customGroup?.vendors)} fontSize='16' color='secondary' />
                              <DeleteIcon onClick={() => { setIsDeleteAlertOn(true); setGroupToDelete(customGroup); }} fontSize='16' color='error' />
                            </div>
                          </ListItemButton>
                          <Divider />
                        </>
                      ))}
                    </InfiniteScroll>
                  </List>
                </Col>
                <Col sm="8" style={{ maxHeight: 350, minHeight: 350, overflow: 'auto' }}>
                  {isEditModeOn ?  
                    <Form>
                      <div>
                        <TextField
                          id="standard-search"
                          label="Group Name"
                          type="text"
                          variant="outlined"
                          className='customTextField'
                          style={{ marginTop: 10 }}
                          value={groupToEditName}
                          onChange={(e) => setGroupToEditName(e.target.value)}
                        />

                        <TextField
                          id="standard-search"
                          label="Add Number(s)"
                          type="text"
                          variant="outlined"
                          onKeyDown={handleKeyPress}
                          onPaste={handlePaste}
                          className="customTextField"
                          value={manualNumberValue}
                          style={{ marginTop: 10 }}
                          onChange={handleInputChange}
                          helperText="Only numbers and special characters (+, -, (, ), space, ; are allowed)"
                        />

                        <Button style={{ marginBottom: 10, marginTop: 10 }} onClick={() => setIsSearchPopupOpen(true)}>Add Vendors</Button>
                        <Button style={{ marginBottom: 10, marginTop: 10 }} onClick={() => fileInputRef.current.click()}>Upload Numbers</Button>
                        <input
                          type="file"
                          accept=".csv"
                          ref={fileInputRef}
                          style={{ display: 'none' }}
                          onChange={handleFileChange}
                        />
                        
                        {groupVendorsToEdit && groupVendorsToEdit.length > 0 && <div className={classes.groupTo} style={{ marginBottom: 10, alignItems: 'center' }}>
                          <span className={classes.toPart}>Vendors:</span>
                          <div style={{ display: 'flex', alignItems: 'center', columnGap: 10, rowGap: 10, overflow: 'auto' }}>
                            {!isSearchPopupOpen && groupVendorsToEdit && groupVendorsToEdit.length > 0 && groupVendorsToEdit.map((vendor, index) => {
                              return (
                                <Chip
                                  key={index}
                                  label={vendor.vendor_name ? vendor.vendor_name : vendor.name}
                                  onDelete={() => removeVendorFromGroupToEdit(index)}
                                />
                              )
                            })}
                          </div>
                        </div>}

                        {manualAddedNumbers && manualAddedNumbers.length > 0 && <div className={classes.groupTo} style={{ marginBottom: 10, marginTop: 10, alignItems: 'center' }}>
                          <span className={classes.toPart}>Numbers:</span>
                          <div style={{ display: 'flex', alignItems: 'center', columnGap: 10, rowGap: 10, overflow: 'auto' }}>
                            {manualAddedNumbers && manualAddedNumbers.length > 0 && manualAddedNumbers.map((number, index) => {
                              return (
                                <Chip
                                  key={index}
                                  label={number}
                                  onDelete={() => handleManualNumberDeleteChip(number)}
                                />
                              )
                            })}
                          </div>
                        </div>}
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', columnGap: 10 }}>
                        <Button color="primary" onClick={() => updateCustomGroup()}>
                          Update
                        </Button>
                        <Button color="secondary" onClick={() => setEditModeOn(false)}>
                          Cancel
                        </Button>
                      </div>
                    </Form>
                    :
                    <>
                      <div style={{ paddingTop: 20, paddingBottom: 10, fontWeight: 500, position: 'sticky', top: 0, backgroundColor: 'white' }}>{selectedCustomGroup?.group_name}</div>
                      <div className={classes.vendorCards}>
                        {selectedCustomGroup && selectedCustomGroup.vendors && selectedCustomGroup.vendors.length > 0 && selectedCustomGroup.vendors.map((vendor, index) => {
                          return (
                            <div className={`d-flex bg-white p-2 overflow-hidden text-truncate ${classes.vendorCard}`}>
                              <div className={classes.picture} style={{ backgroundColor: generateAvatarBackgroundColor(vendor?.vendor_name ? vendor?.vendor_name : vendor?.phone_number) }}>{!vendor?.vendor_name ? <PersonIcon /> : vendor?.vendor_name.trim().split(' ').slice(0,2).reduce((acc, name) => acc+name[0],'')}</div>
                              <div className={`overflow-hidden`}>
                              {vendor?.vendor_name && <div className="overflow-hidden text-truncate" style={{fontSize: '15px', fontWeight: '500'}}>{vendor?.vendor_name}</div>}
                                <div className="overflow-hidden text-truncate" style={{fontSize: '12px'}}>{vendor?.phone_number}</div>
                              </div>
                            </div>
                          )
                        })}
                        {selectedCustomGroup && selectedCustomGroup.vendors?.length === 0 && <div style={{ color: 'rgb(103 103 103)' }}>No Contacts in this group!</div>}
                      </div>
                    </>
                  }
                </Col>
              </Row>
            }
          </div>}

          {activeTab === 3 && <div style={{ paddingLeft: '1rem', paddingRight: '1rem' }}>
            {isVendorsOnCampaignGroupsLoading ?
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 100 }}>
                <Spinner style={{ color: boxiPrimary }} />
              </div>
              :
              <Row style={{ maxHeight: 'inherit', minHeight: 'inherit' }}>
                <Col sm="12" style={{ maxHeight: 350, minHeight: 350, overflow: 'auto' }}>
                  <div style={{ display: 'flex', alignItems: 'center', columnGap: 10, paddingTop: 20, paddingBottom: 10, fontWeight: 500, position: 'sticky', top: 0, backgroundColor: 'white'  }}>
                    {isSelection && <ListItemIcon style={{ minWidth: 0 }} onClick={() => handleGroupToggle({vendorGroupName: `Vendors On Campaigns (${moment.tz('America/Los_Angeles').format('MMMM')})`, vendors: vendorsOnCampaignGroups})}>
                      <Checkbox
                        edge="start"
                        checked={checked.filter(val => val.vendorGroupName).map(val => val.vendorGroupName).indexOf(`Vendors On Campaigns (${moment.tz('America/Los_Angeles').format('MMMM')})`) !== -1}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{ 'aria-labelledby': `Vendors On Campaigns (${moment.tz('America/Los_Angeles').format('MMMM')})` }}
                      />
                    </ListItemIcon>}
                    <div>{`Vendors On Campaigns (${moment.tz('America/Los_Angeles').format('MMMM')})`}</div>
                  </div>
                  <div className={classes.vendorCards} style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
                    {vendorsOnCampaignGroups && vendorsOnCampaignGroups.length > 0 && vendorsOnCampaignGroups.map((vendor, index) => {
                      return (
                        <div className={`d-flex bg-white p-2 overflow-hidden text-truncate ${classes.vendorCard}`}>
                          {vendor?.vendor_name && <div className={classes.picture} style={{ backgroundColor: generateAvatarBackgroundColor(vendor?.vendor_name) }}>{vendor.vendor_name[0] === '+' ? <PersonIcon /> : vendor?.vendor_name.trim().split(' ').slice(0,2).reduce((acc, name) => acc+name[0],'')}</div>}
                          <div className={`overflow-hidden`}>
                            {vendor?.vendor_name && <div className="overflow-hidden text-truncate" style={{fontSize: '15px', fontWeight: '500'}}>{vendor?.vendor_name}</div>}
                            <div className="overflow-hidden text-truncate" style={{fontSize: '12px'}}>{vendor?.phone_number}</div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </Col>
              </Row>
            }
          </div>}

          {/* Delete Group Alert */}
          <Dialog onClose={() => setIsDeleteAlertOn(false)} open={isDeleteAlertOn} className="deleteAlertDialog">
            <div>This action will permanently delete this group. Are you sure you want to continue?</div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', columnGap: 10 }}>
              <LoadingButton loading={isGroupDeleting} disabled={isGroupDeleting} color="error" onClick={() => deleteGroup()}>
                Delete
              </LoadingButton>
              <Button color="secondary" disabled={isGroupDeleting} onClick={() => setIsDeleteAlertOn(false)}>
                Cancel
              </Button>
            </div>
          </Dialog>

        </ModalBody>
        <ModalFooter>
          {activeTab == 3 && <Button disabled={vendorsOnCampaignGroups.length === 0} onClick={() => duplicateVendorOnCampaignGroup()}>Duplicate</Button>}
          {isSelection && <Button disabled={checked.length == 0} onClick={() => { setSelectedGroup(checked); openModal(false); setIsSelection(false); }}>Add Groups</Button>}
          <Button disabled={activeTab !== 2 || isEditModeOn} color="tertiary" onClick={() => { closeAddNewModal(true); setIsSelection(false); }}>
            Add New
          </Button>
        </ModalFooter>
      </Modal>

      {/* Add Group Modal */}
      <Modal backdrop="static" className="composeModal" isOpen={isAddModalOpen} toggle={() => toggleAddNewModal()}>
        <ModalHeader toggle={() => toggleAddNewModal()}>Add New Custom Group</ModalHeader>
        <ModalBody>
          <Form>
            <div>
              <TextField
                id="standard-search"
                label="Group Name"
                type="text"
                variant="outlined"
                className='customTextField'
                onChange={(e) => setGroupInputValue(e.target.value)}
              />


              <TextField
                id="standard-search"
                label="Add Number(s)"
                type="text"
                variant="outlined"
                onKeyDown={handleKeyPress}
                onPaste={handlePaste}
                className="customTextField"
                value={manualNumberValue}
                style={{ marginTop: 20 }}
                onChange={handleInputChange}
                helperText="Only numbers and special characters (+, -, (, ), space, ; are allowed)"
              />

              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Button style={{ marginBottom: 10, marginTop: 10 }} onClick={() => setIsSearchPopupOpen(true)}>Add Vendors</Button>
                <Button style={{ marginBottom: 10, marginTop: 10 }} onClick={() => fileInputRef.current.click()}>Upload CSV</Button>
                <InfoIcon aria-describedby={id} onClick={handleClick} color="primary" fontSize="small" style={{ marginBottom: 2, cursor: 'pointer' }} />
              </div>

              <input
                type="file"
                accept=".csv"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
              />
              
              {selectedVendors && selectedVendors.length > 0 && <div className={classes.groupTo} style={{ marginBottom: 10, alignItems: 'center' }}>
                <span className={classes.toPart}>Vendors:</span>
                <div style={{ display: 'flex', alignItems: 'center', columnGap: 10, rowGap: 10, overflow: 'auto' }}>
                  {!isSearchPopupOpen && selectedVendors && selectedVendors.length > 0 && selectedVendors.map((vendor, index) => {
                    return (
                      <Chip
                        key={index}
                        label={vendor.name}
                        onDelete={() => handleDeleteChip(vendor)}
                      />
                    )
                  })}
                </div>
              </div>}

              {manualAddedNumbers && manualAddedNumbers.length > 0 && <div className={classes.groupTo} style={{ marginBottom: 10, marginTop: 10, alignItems: 'center' }}>
                <span className={classes.toPart}>Numbers:</span>
                <div style={{ display: 'flex', alignItems: 'center', columnGap: 10, rowGap: 10, overflow: 'auto' }}>
                  {manualAddedNumbers && manualAddedNumbers.length > 0 && manualAddedNumbers.map((number, index) => {
                    return (
                      <Chip
                        key={index}
                        label={number}
                        onDelete={() => handleManualNumberDeleteChip(number)}
                      />
                    )
                  })}
                </div>
              </div>}
            </div>
          </Form>
        </ModalBody>
        <ModalFooter>
          <LoadingButton loading={isCustomGroupSaving} disabled={isCustomGroupSaving || groupInputValue.length === 0 || (selectedVendors.length === 0 && manualAddedNumbers.length === 0)} color="primary" onClick={() => createCustomGroup()}>
            Save
          </LoadingButton>
          <Button disabled={isCustomGroupSaving} color="secondary" onClick={() => toggleAddNewModal()}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <VendorSearch isSearchPopupOpen={isSearchPopupOpen} setIsSearchPopupOpen={setIsSearchPopupOpen} selectedVendors={isEditModeOn ? groupVendorsToEdit : selectedVendors} setSelectedVendors={isEditModeOn ? setGroupVendorsToEdit : setSelectedVendors} />

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Typography sx={{ p: 2, fontFamily: 'Poppins' }}>You can upload a CSV and all numbers in the file will be extracted.<br />You can <a href="https://boxi-truck-images.s3.us-west-2.amazonaws.com/Phone+Numbers+Upload+CSV+-+TEMPLATE.csv" download>download a sample template CSV</a> for more instructions.</Typography>
      </Popover>
    </>
  )
}

export default Groups